// Libraries
import { ChangeEvent, FC } from "react";

// Types
import { InputV2Props } from "./InputV2.types";

export const InputV2: FC<InputV2Props> = ({
  id,
  label,
  placeholder,
  value,
  defaultValue = "",
  onChange,
  className,
  inputProps,
}) => {
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e);

  return (
    <div className={`flex flex-row gap-4 items-center justify-between ${className}`}>
      {label && (
        <label htmlFor={id} className="max-w-[30%] w-auto text-left text-regular-2 opacity-80">
          {label}
        </label>
      )}
      <input
        id={id}
        type="text"
        className="text-foreground group rounded-md w-full flex flex-row items-center justify-between p-2 card-border bg-muted focus-within:outline-none"
        placeholder={placeholder ?? `Enter ${label}`}
        {...(typeof value === "string" && { value })}
        defaultValue={defaultValue}
        onChange={handleInputChange}
        {...(inputProps || {})}
      />
    </div>
  );
};

export default InputV2;
